import React from 'react';
import { Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import useServices from '../../../../hooks/useServices';
import Service from '../Service/Service';

const Services = () => {
    const [services] = useServices();
    // console.log(services);

    let shouldSkip = false;
    let rest = [];
    const handleServices = () => {
        services.forEach(element => {
            if (shouldSkip) return;
            if (rest.length <= 2) {
                rest.push(element);
            }
            // console.log(rest);
            if (rest.length === 3) {
                shouldSkip = true;
            }
        })
    }
    handleServices();

    return (
        <div className='my-5'>
            <h2 className='mb-4'>Service Categories: <span className='text-warning'>{rest.length}</span></h2>
            <Row xs={1} md={1} lg={1} className="g-4 mx-2 mx-sm-5 mx-md-5 ms-lg-5">
                {
                    rest.map(service => <Service
                        key={service.id}
                        service={service}
                    ></Service>)
                }
            </Row>
            <Link to='/services' className='btn btn-outline-success mt-4'> Explore All Service Categories</Link>
        </div>
    );
};

export default Services;